export abstract class Controller {
    protected abstract updateStore(): void;
}
